import React, { useEffect, useState } from "react";
import "../css/LandingPage.css";
import { useNavigate } from "react-router-dom";
import { displayCategory } from "../config/categories";
import { getDatabase, set, onValue, ref, push } from "firebase/database";
import LoaderComponent from "../component/LoaderComponent";
import GlobalBuyerSection from "../component/GlobalBuyerSection";
import B2BCapabilities from "../component/B2BCapabilities";
import B2BCapabilities_HowItWork from "../component/B2BCapabilities_HowITWork";

const LandingPage = () => {
	const navigate = useNavigate();
	const [categories, setCategories] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		const db = getDatabase();
		const categoryRef = ref(db, "categories");

		const unsubscribe = onValue(categoryRef, (snapshot) => {
			const data = snapshot.val();
			if (!data) {
				setCategories([]);
				setLoading(false);
				return;
			}

			const categoryArray = Object.values(data);
			setCategories(categoryArray);
			setLoading(false);
		});

		return () => {
			setLoading(true);
			unsubscribe();
		};
	}, []);

	const handleExploreClick = () => {
		if (categories.length === 0) return;

		const firstCategory = categories[0]; // 👈 top / first category
		navigate(`/categories/${firstCategory.path}`);
		window.scrollTo(0, 0);
	};

	return (
		<div>
			{loading ? <LoaderComponent /> : ""}

			{/* CAROUSELSS */}
			<div
				id="carouselExampleFade"
				className="carousel slide carousel-fade m-0"
				data-ride="carousel"
			>
				<ol className="carousel-indicators">
					<li
						data-target="#carouselExampleFade"
						data-slide-to="0"
						className="active"
					></li>
					<li
						data-target="#carouselExampleFade"
						data-slide-to="1"
					></li>
					<li
						data-target="#carouselExampleFade"
						data-slide-to="2"
					></li>
					<li
						data-target="#carouselExampleFade"
						data-slide-to="3"
					></li>
				</ol>
				<div className="carousel-inner">
					<div className="carousel-item active">
						<img
							className="d-block w-100"
							src="/images/carousel/carousel_2.png"
							alt="First slide"
						/>
					</div>
					<div className="carousel-item">
						<img
							className="d-block w-100"
							src="/images/carousel/carousel_1.png"
							alt="Second slide"
						/>
					</div>
					<div className="carousel-item">
						<img
							className="d-block w-100"
							src="/images/carousel/carousel_3.png"
							alt="Third slide"
						/>
					</div>
					<div className="carousel-item">
						<img
							className="d-block w-100"
							src="/images/carousel/carousel_4.png"
							alt="Third slide"
						/>
					</div>
				</div>
				<a
					class="carousel-control-prev"
					href="#carouselExampleFade"
					role="button"
					data-slide="prev"
				>
					<span
						class="carousel-control-prev-icon"
						aria-hidden="true"
					></span>
					<span class="sr-only">Previous</span>
				</a>
				<a
					class="carousel-control-next"
					href="#carouselExampleFade"
					role="button"
					data-slide="next"
				>
					<span
						class="carousel-control-next-icon"
						aria-hidden="true"
					></span>
					<span class="sr-only">Next</span>
				</a>
			</div>

			{/* BRAND INTRO TRANSITION */}
			<section className="brand-intro-section">
				<div className="container">
					<p className="brand-intro-subtitle">
						DESIGN • HERITAGE • CRAFTSMANSHIP
					</p>

					<h1 className="brand-intro-title">
						Design-Driven Rug Manufacturing for Global Projects
					</h1>

					<div className="brand-intro-divider"></div>

					<p className="brand-intro-text">
						Blumeessa is an export-ready rug manufacturer with
						in-house design, development, quality control, and
						global shipping — delivering custom and bulk rugs for
						international buyers, designers, and brands.
					</p>
				</div>
			</section>

			{/* PARALLAX STORY SECTION */}
			<section className="parallax-section mt-5">
				<img
					src="/images/banner/rug_parallex_1.png"
					alt="Luxury Rugs"
					className="parallax-img"
				/>
				<div className="parallax-overlay">
					<div className="parallax-content">
						<p className="parallax-subtitle">
							HANDCRAFTED LUXURY RUGS
						</p>
						<h2 className="parallax-title">
							Where Heritage Meets Modern Living
						</h2>
						<p className="parallax-text">
							Each Blumeessa rug is a work of art — handwoven by
							master artisans using centuries-old techniques.
						</p>
						<button
							className="btn parallax-btn"
							onClick={handleExploreClick}
						>
							EXPLORE COLLECTION
						</button>
					</div>
				</div>
			</section>

			<div className="product-catogery">
				<div className="container content">
					<div className="text-center category-header">
						<span>Our Category</span>
					</div>

					<div className="row rowPart1 text-center">
						{loading && <p>Loading categories...</p>}

						{!loading &&
							categories.map((item) => (
								<div
									key={item.id}
									className="col-lg-4 col-12 image1 container"
									onClick={() => {
										navigate(`/categories/${item.path}`);
										window.scrollTo(0, 0);
									}}
								>
									<div className="img-wrapper">
										<img src={item.img} alt={item.title} />
										{item.text && (
											<div className="img-text">
												{item.text}
											</div>
										)}
									</div>

									<button className="btn category-btn">
										<b>{item.title}</b>
									</button>
								</div>
							))}
					</div>
				</div>
			</div>

			{/* GLOBAL BUYER */}
			<GlobalBuyerSection />

			{/* <div className="gradient-divider"></div> */}

			{/* {B2B capabilities} */}
			<div className="section-split my-5">
				<div className="badge">B2B CAPABILITIES</div>
			</div>
			<B2BCapabilities />
			<div className="gradient-divider"></div>
			<B2BCapabilities_HowItWork />

			{/* BRAND VALUES */}
			<section className="brand-values">
				<div className="container">
					<p className="brand-values-subtitle">OUR PHILOSOPHY</p>
					<h2 className="brand-values-title">
						Crafted with Purpose & Precision
					</h2>

					<div className="d-flex justify-content-center flex-wrap text-center brand-values-row">
						<div className="col-lg-3 value-box">
							<div className="value-icon">
								<i className="fa fa-hand-paper-o"></i>
							</div>
							<h4>Manufacturing-Led Craftsmanship</h4>
							<p>
								Production executed through skilled artisan
								units following defined quality and design
								standards
							</p>
						</div>

						<div className="col-lg-3 value-box">
							<div className="value-icon">
								<i className="fa fa-leaf"></i>
							</div>
							<h4>Material-Focused Development</h4>
							<p>
								Natural and blended fibers selected based on
								durability, performance, and project suitability
							</p>
						</div>

						<div className="col-lg-3 value-box">
							<div className="value-icon">
								<i className="fa fa-diamond"></i>
							</div>
							<h4>Project-Driven Customization</h4>
							<p>
								Rugs developed to meet brand, design, and
								contract specifications — not one-off pieces
							</p>
						</div>
					</div>
				</div>
			</section>

			{/* FOOTER */}
			<div className="footer">
				<div className="col-lg-4 col-md-4 col-12 mb-md-4">
					<div className="footer-bg">
						<i
							className="fa fa-map-marker pr-3"
							style={{ fontSize: "25px", color: "#2a2929" }}
						></i>
						<span>Head Office / Headquarters </span>
						<br />
						<div className="footer-div mb-2">
							<p>
								Blumeessa F15-1306, Centurian Park O2 Valley
								Sector Techzone 4 Greater Noida West, Uttar
								Pradesh, India
							</p>
							<p className="mb-1">
								Manufacturing Units: Bhadohi & Panipat,{" "}
							</p>
							<p className="mb-0">
								India — In-house Rug Manufacturing
							</p>
						</div>
					</div>
					<hr className="visible-xs" />
				</div>

				<div className="col-lg-4 col-md-4 col-12 ">
					<div className="footer-bg">
						<i
							className="fa fa-envelope footer-icon pr-3"
							style={{
								fontSize: "25px",
								color: "#2a2929",
								fontWeight: "250",
							}}
						></i>
						<span className="contact-txt">General Enquiries</span>
						<br />
						<div className="footer-div">
							<div className="py-2">prashant@blumeessa.com</div>
							<div>abha@blumeessa.com</div>
						</div>
					</div>
					<hr className="visible-xs text-center" />
				</div>

				<div className="col-lg-4 col-md-4 col-12">
					<div className="footer-bg">
						<i
							className="fa fa-phone pr-3"
							style={{
								fontSize: "22px",
								color: "#2a2929",
								fontWeight: "250",
							}}
						></i>
						<span>Call Us</span>
						<br />
						<div className="footer-div">
							<div className="py-2">+91-9711995505</div>
							<div>+91-1204848403</div>
							<div>+49-17662541561</div>
							<br />
						</div>
					</div>
					<hr className="visible-xs" />
				</div>
			</div>
		</div>
	);
};

export default LandingPage;
